import React, { useState } from 'react';
import MainTopBar from '../MainTopBar/MainTopBar';
import arrowDown from '../../../../images/arrow-down.svg';
import settingsIcon from '../../../../images/settings-icon.svg';
import './ChatTopBar.css';

interface Props {
  isSticky: boolean;
  isLoggedIn: boolean;
  showAdminButton: boolean;
  additionalLeftChildren?: React.ReactNode;
  additionalMiddleChildren?: React.ReactNode;
  additionalRightChildren?: React.ReactNode;
  // Required package selection props for chat
  selectablePackages: string[];
  selectedPackages: string[];
  onPackageSelect: (packageName: string) => void;
  onSettingsClick?: () => void;
  // User props
  userName?: string;
}

const ChatTopBar: React.FC<Props> = ({
  isSticky,
  isLoggedIn,
  showAdminButton,
  additionalLeftChildren,
  additionalMiddleChildren,
  additionalRightChildren,
  selectablePackages,
  selectedPackages,
  onPackageSelect,
  onSettingsClick,
  userName = 'User',
}) => {
  // Dropdown state
  const [isOpen, setIsOpen] = useState(false);

  // Get the currently selected package name
  const getSelectedPackageName = (): string => {
    if (selectedPackages.length > 0) {
      return selectedPackages[0];
    }
    if (selectablePackages.length > 0) {
      return selectablePackages[0];
    }
    throw new Error('No packages available for selection');
  };

  const handlePackageSelection = (packageName: string) => {
    onPackageSelect(packageName);
    setIsOpen(false);
  };

  // Create package dropdown component
  const packageDropdown =
    isLoggedIn && selectablePackages.length > 0 ? (
      <div className="MainTopBar-SearchDropdownContainer">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="MainTopBar-SearchDropdown-ToggleButton"
        >
          {getSelectedPackageName()}
          <span className="ml-2">
            <img src={arrowDown} alt="Arrow Down" />
          </span>
        </button>

        {isOpen && (
          <ul className="MainTopBar-SearchDropdown-DropdownMenu">
            {selectablePackages.map((packageName, index) => (
              <li
                key={index}
                onClick={() => handlePackageSelection(packageName)}
                className="SearchDropdown-DropdownMenuS-item"
              >
                {packageName}
              </li>
            ))}
          </ul>
        )}
      </div>
    ) : null;

  // Render hamburger icon (additionalLeftChildren) first, then package dropdown
  const leftChildren = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
      {additionalLeftChildren}
      {packageDropdown}
    </div>
  );

  // Settings icon to show before user menu
  const settingsButton = onSettingsClick ? (
    <div
      className="chat-topbar-settings-icon"
      onClick={onSettingsClick}
      style={{ cursor: 'pointer', marginRight: '0.75rem' }}
    >
      <img src={settingsIcon} alt="Settings" />
    </div>
  ) : null;

  return (
    <MainTopBar
      isSticky={isSticky}
      isLoggedIn={isLoggedIn}
      showAdminButton={showAdminButton}
      additionalLeftChildren={leftChildren}
      additionalMiddleChildren={additionalMiddleChildren}
      additionalRightChildren={additionalRightChildren}
      beforeUserChildren={settingsButton}
      userName={userName}
    />
  );
};

export default ChatTopBar;
